import React, { useState } from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';

import { Image } from '../../foundations/Image/Image';
import { buildImageSizes } from '../../foundations/Image/utils/buildImageSizes';
import { buildImageSrcSet } from '../../foundations/Image/utils/buildImageSrcSet';
import type { YouTubeVideoProps } from './types';
import * as styles from './YouTubeVideo.styles';

export const YouTubeVideo = ({
  lazyImages,
  onVideoClick,
  onVisible = () => {},
  thumbnailHeight,
  thumbnailImages,
  thumbnailWidth,
  videoDescription = '',
  youtubeId,
}: YouTubeVideoProps) => {
  const hasThumbnail = Boolean(thumbnailImages.length) && thumbnailWidth && thumbnailHeight;
  const [renderVideo, setRenderVideo] = useState(!hasThumbnail);
  const [displayThumbnail, setDisplayThumbnail] = useState(hasThumbnail);

  const observedElementRef = useImpressionRef<HTMLDivElement>(() => onVisible());

  return (
    <div css={styles.videoWrapper} ref={observedElementRef}>
      {hasThumbnail && displayThumbnail && (
        <button
          css={styles.button}
          onClick={(e) => {
            setRenderVideo(true);
            onVideoClick?.(e);
          }}
        >
          <Image
            alt="load video"
            css={styles.thumbnail}
            height={thumbnailHeight}
            loading={lazyImages ? 'lazy' : 'eager'}
            sizes={buildImageSizes({
              M: '75vw',
              XL: '920px',
            })}
            src={thumbnailImages[0]?.src}
            srcSet={buildImageSrcSet(
              thumbnailImages.map(({ src, width }) => ({ src, width, unit: 'w' })),
            )}
            width={thumbnailWidth}
          />
        </button>
      )}
      {renderVideo && (
        <iframe
          allow="autoplay; encrypted-media"
          css={[styles.iframe, displayThumbnail && styles.hidden]}
          frameBorder="0"
          onLoad={() => {
            if (hasThumbnail) {
              setDisplayThumbnail(false);
            }
          }}
          src={`//www.youtube-nocookie.com/embed/${youtubeId}?rel=0&autohide=2&border=0&wmode=opaque&enablejsapi=1&showinfo=0`}
          title={`youtube video ${videoDescription}`}
        />
      )}
    </div>
  );
};
